var Curriculog = Curriculog || {};

Curriculog.UserRoles = (function ($, _, Backbone, UserRoles) {

	UserRoles = Curriculog.CurriculogCollection.extend({
		url: 'rest/userrole',
		model: Curriculog.UserRole,

		getUserRolesForRole: function (roleID) {
			var models = this.filter(function (model) {
				return model.get('role_id') === roleID;
			});
			return models;
		},

		getUserRolesForUser: function (userID) {
			var models = this.filter(function (model) {
				return model.get('user_id') === userID;
			});
			return models;
		},

		getUsersForRole: function (roleID) {
			var userRoles = this.getUserRolesForRole(roleID);

			return userRoles.map(function (model){
				return model.get('user_id');
			});
		},

		getRolesForUser: function (userID) {
			var userRoles = this.getUserRolesForUser(userID);

			return userRoles.map(function (model){
				return model.get('role_id');
			});
		},

		swapUser: function (roleID, oldUser, newUser) {
			var newUserAlreadyInRole = this.findWhere({
				user_id: newUser,
				role_id: roleID,
			});

			var userRoleRecord = this.findWhere({
				user_id: oldUser,
				role_id: roleID,
			});

			if (newUserAlreadyInRole !== undefined) {
				// new user already has this role
				// remove old user's user_role record
				this.remove(userRoleRecord);
			} else {
				// new user is not yet in this role
				// update the existing user role record
				userRoleRecord.set({user_id: newUser});
			}
		},

	});
	return UserRoles;

})($, _, Backbone, Curriculog.UserRoles || {});
